export default {
  accessTokenName: process.env.NEXT_PUBLIC_ACCESS_TOKEN_COOKIE_NAME,
  refreshTokenName: process.env.NEXT_PUBLIC_REFRESH_TOKEN_COOKIE_NAME,
  grantTokenName: process.env.NEXT_PUBLIC_GRANT_TOKEN_COOKIE_NAME,
  chatTokenName: process.env.NEXT_PUBLIC_CHAT_TOKEN_COOKIE_NAME,
  basicAuth: process.env.NEXT_PUBLIC_BASIC_AUTH,
}
